import { Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { FormBasic } from 'src/app/models/turns-models/turns-form-basic.model';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { FormsTurnsService } from 'src/app/services/turns-services/forms-turns-service/forms-turns.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-turns-form-operative-card',
  templateUrl: './turns-form-operative-card.component.html',
  styleUrls: ['./turns-form-operative-card.component.scss']
})
export class TurnsFormOperativeCardComponent implements OnInit, OnChanges, OnDestroy {

  @Input() form: FormBasic;

  operativeForm = new FormGroup({
    maxTurnsPerDayByService: new FormControl(0),
    showEstimatedTime: new FormControl(false)
  });

  updateFormTurnsOperativeSubscription: Subscription;

  constructor(private formsTurnsService: FormsTurnsService,
              private snackbarService: SnackBarService) { }

  ngOnInit() { }

  ngOnChanges() {
    if (this.form) {
      this.resetForm();
    }
  }

  private resetForm() {
    this.operativeForm.patchValue({
      maxTurnsPerDayByService: this.form.MaxTurnsPerDayByService,
      showEstimatedTime: this.form.ShowEstimatedTime
    });
  }

  public submitForm() {
    this.updateFormTurnsOperativeSubscription = this.formsTurnsService.updateFormTurnsOperative(this.form.InternalId, this.operativeForm.get('maxTurnsPerDayByService').value, this.operativeForm.get('showEstimatedTime').value).subscribe(
      (res) => {
        this.snackbarService.open('turns-page.snackbar messages.update form success', 'success');
        this.formsTurnsService.refreshForm();
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  ngOnDestroy() {
    if (this.updateFormTurnsOperativeSubscription) { this.updateFormTurnsOperativeSubscription.unsubscribe(); }
  }
}
